import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs-compat/Observable'
import { OrderApiConfiguration } from '../order-api-configuration';
import { ServiceBase } from '../../../infrastructure/serviceBase.component';


@Injectable({
    providedIn: 'root'
})
export class MedicalProceduresReportTemplateService extends ServiceBase {

    private actionUrl: string;
    private _url: string;

    private _byActionId: string;
    private _logsByTemplateId: string;
    private _logsByActionId: string;

    constructor(private _http: HttpClient, private _configuration: OrderApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
        this._url = this.actionUrl + _configuration.medicalProceduresReportTemplate.url;
        this._byActionId = this.actionUrl + _configuration.medicalProceduresReportTemplate.byActionId;
        this._logsByTemplateId = this.actionUrl + _configuration.medicalProceduresReportTemplate.logByTemplateId;
        this._logsByActionId = this.actionUrl + _configuration.medicalProceduresReportTemplate.logByActionId;
    }

    getLogsByReportId = (id: any): Observable<any> => {
        const url = `${this._logsByTemplateId}?id=${id}`;
        return this._http.get<any>(url);
    }

    getLogsByActionId = (actionId: any): Observable<any> => {
        const url = `${this._logsByActionId}?actionId=${actionId}`;
        return this._http.get<any>(url);
    }
    getById = (id): Observable<any> => {
        const url = `${this._url}?id=${id}`;
        return this._http.get<any>(url);
    }
    getByActionId = (id): Observable<any> => {
        const url = `${this._byActionId}?id=${id}`;
        return this._http.get<any>(url);
    }

    add = (data: any): Observable<any> => {
        return this._http.post<any>(this._url, data);
    }

    update = (data: any): Observable<any> => {
        const url = `${this._url}`;
        return this._http.put<any>(url, data);
    }
}
